<ion-header class="ion-no-border" style="--background:transparent" lines="none">
  <ion-toolbar class="ion-no-border" style="--background:transparent" lines="none">
    <ion-button shape="round" color="danger" (click)="close()" slot="end">
      <ion-icon name="close" slot="icon-only"></ion-icon>
    </ion-button>
  </ion-toolbar>
</ion-header>


<ion-content [scrollEvents]="true" (ionScroll)="handleScroll($any($event))">
  <ion-list *ngFor="let Document of Documents">
    <ion-img *ngIf="Document.isNotLoaded" style="width: 250px; margin: 0 auto;" src="{{Document.PictureSrc}}"></ion-img>
    <ion-img *ngIf="!Document.isNotLoaded" style="max-width: 800px; margin: 0 auto;"
      src="{{Document.PictureSrc}}"></ion-img>
  </ion-list>
</ion-content>

<ion-item (click)="clickOnCheckbox($event)" lines="none"
  *ngIf="(this.manager.Navi.isSelected('register') || this.manager.Navi.isSelected('crea')) &&  this.handler != null">
  <ion-checkbox class="ion-text-wrap" style="font-size: 16px" labelPlacement="end" justify="start"
    [(ngModel)]="dataAccepted">
    {{manager.Trad.Parse("STR_DATA_TRANFERT_ACCEPT")}}</ion-checkbox>
</ion-item>
<ion-item (click)="clickOnCheckbox($event)" lines="none"
  *ngIf="(this.manager.Navi.isSelected('register') || this.manager.Navi.isSelected('crea')) &&  this.handler != null">
  <ion-checkbox class="ion-text-wrap" style="font-size: 16px" labelPlacement="end" justify="start"
    [(ngModel)]=" termsAccepted">{{manager.Trad.Parse("STR_TERMS_ACCEPT")}}</ion-checkbox>
  <!-- <ion-label for="termsCheckbox" class="ion-text-wrap" style="font-size: 16px">
    {{manager.Trad.Parse("STR_TERMS_ACCEPT")}}</ion-label> -->
</ion-item>


<!-- old version bouton qui sont disbaled si non scroll
  <ion-item lines="none" *ngIf="(this.manager.Navi.isSelected('register') || this.manager.Navi.isSelected('crea')) &&  this.handler != null">
  <ion-checkbox slot="start" [disabled]="!IsFullyScrolled && this.manager.Navi.isSelected('register')" [(ngModel)]="dataAccepted"></ion-checkbox>
  <ion-label class="ion-text-wrap" style="font-size: 16px"> {{manager.Trad.Parse("STR_DATA_TRANFERT_ACCEPT")}}</ion-label>
</ion-item>
<ion-item lines="none" *ngIf="(this.manager.Navi.isSelected('register') || this.manager.Navi.isSelected('crea')) &&  this.handler != null">
  <ion-checkbox slot="start" [disabled]="!IsFullyScrolled && this.manager.Navi.isSelected('register')" [(ngModel)]="termsAccepted"></ion-checkbox>
  <ion-label class="ion-text-wrap" style="font-size: 16px"> {{manager.Trad.Parse("STR_TERMS_ACCEPT")}}</ion-label>
</ion-item> -->

<ion-footer class="ion-no-border" style="--background:transparent" lines="none"
  style="display: flex;justify-content: center;margin:8px 0"
  *ngIf="(this.manager.Navi.isSelected('register') || this.manager.Navi.isSelected('crea')) &&  this.handler != null">
  <ion-button shape="round" color="primary" (click)="this.acceptCgu()">
    <ion-text class="ion-text-center">{{manager.Trad.Parse("STR_ACCEPT")}}</ion-text>
  </ion-button>
</ion-footer>